/**
 * 我的客户
 */
<template>
  <div style="margin-top: 20px;">
      <!-- 左边导航 -->
      <div style="margin-bottom: 12px;font-weight: 700;float: left;display: flex;line-height: 40px;height: 40px;">
        <div class="mouse" v-if="myCustomerListAuth" :class="{'selected':myCustomerListAuthCh}" @click="clickLabel('myCus')">我的客户</div>

        <div class="mouse" v-if="myCustomerAuth" :class="{'selected':myCustomerAuthCh}" @click="clickLabel('list')">客户列表</div>
        <!-- <div style="margin-left: 10px;margin-right: 10px;color: #D9D9D9;">|</div> -->
        <div class="mouse" v-if="intentionCustomerAuth" :class="{'selected':intentionCustomerAuthCh}" @click="clickLabel('intention')">意向客户</div>
        <!-- <div style="margin-left: 10px;margin-right: 10px;color: #D9D9D9;">|</div> -->
        <div class="mouse" v-if="customerPoolAuth" :class="{'selected':customerPoolAuthCh}" @click="clickLabel('pool')">客户公海</div>


        <!-- <div style="margin-left: 10px;margin-right: 10px;color: #D9D9D9;">|</div>
        <div class="mouse" v-if="customerManageAuth" :class="{'selected':customerManageAuthCh}" @click="clickLabel('manage')">客户管理</div> -->
      </div> 
      <!-- 右侧按钮 -->
      <div style="float: right;display: flex;">
        <el-button v-no-more-click size="small" icon="el-icon-refresh" class="clue-btn" @click="refreshData">刷新</el-button>
        <el-button v-if="myCustomerListAuthCh&&addCustomerAuth" size="small" icon="el-icon-plus" class="clue-btn" @click="handleAddCustomer">新增客户</el-button>
        <el-button v-if="myCustomerAuthCh&&adminAddCustomerAuth" size="small" icon="el-icon-plus" class="clue-btn" @click="handleAdminAddCustomer">新增客户</el-button>
        <!-- <el-button v-if="intentionCustomerAuthCh" size="small" icon="el-icon-plus" class="clue-btn" @click="handleAddIntention">新增意向</el-button> -->
        <el-button v-if="myCustomerAuthCh&&importCustomerAuth" size="small" icon="el-icon-top" class="clue-btn" @click="handleExportCustomer">客户导入</el-button>
        <el-button v-if="myCustomerAuthCh&&downloadCustomerAuth" size="small" icon="el-icon-top" class="clue-btn" @click="downloadCustomerCheck">客户下载</el-button>
        <el-button v-if="myCustomerAuthCh&&customerMoveAuth" size="small" icon="el-icon-thumb" class="clue-btn" @click="handleMoveCus" title="将勾选客户移入公海">移入公海</el-button>
        <el-button v-if="myCustomerAuthCh&&customerDistributeAuth" size="small" icon="el-icon-male" class="clue-btn" @click="handleDistributeCus">分配</el-button>
        <el-button v-if="myCustomerListAuthCh&&customerDeleteAuth" size="small" icon="el-icon-delete" class="clue-btn" @click="handleDelCusCheck">删除</el-button>
        <el-button v-if="myCustomerAuthCh&&customerDeleteAuth" size="small" icon="el-icon-delete" class="clue-btn" @click="handleDelCusCheck">删除</el-button>
        <el-button v-if="customerPoolAuthCh&&customerPoolDistributeAuth" size="small" icon="el-icon-male" class="clue-btn" title="回收公海客户" @click="handlePoolDistributeCus">分配</el-button>
        <el-button v-if="customerPoolAuthCh&&customerPoolRecoveryAuth" size="small" icon="el-icon-female" class="clue-btn" title="将公海客户恢复到客户列表" @click="handleRecoveryCusCheck">恢复</el-button>

        <!-- <el-input v-model="formInline.search" placeholder="请输入需要查询的条件" clearable class="clue-search">
          <el-button slot="append" icon="el-icon-search" class="clue-search-btn"></el-button>
        </el-input> -->
      </div>
    <!-- 我的客户列表 -->
    <div v-if="myCustomerListAuthCh">
      <el-table size="small" :data="myCustomerList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column align="center" type="selection" width="40">
        </el-table-column>
        <!-- <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column> -->
        <el-table-column prop="customer_name" align="center" label="客户名称" min-width="180" fixed="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #407AA8;cursor: pointer;" title="查看客户详情" @click="handleCustomerInfo(scope.$index, scope.row)">{{ scope.row.customer_name }}</span>
            <span v-if="scope.row.is_new==2" class="newTag">new</span>
          </template>
        </el-table-column>
        <el-table-column prop="contacts" align="center" label="联系人" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #407AA8;cursor: pointer;" title="查看所有联系人" @click="editContacts(scope.$index, scope.row)">{{ scope.row.contacts }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="inventors" align="center" label="前二发明人" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #407AA8;cursor: pointer;" title="查看所有发明人" @click="viewInventors(scope.$index, scope.row)">{{ scope.row.inventors }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="admin_name" align="center" label="当前跟进人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="old_admin_name" align="center" label="历史跟进人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="customer_type" align="center" label="客户类型" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="organ" align="center" label="部门/院系" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="position" align="center" label="职位/岗位" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="origin" align="center" label="来源" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="添加时间" width="120" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column align="center" label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" :disabled="scope.row.able" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!--客户列表-->
    <div v-if="myCustomerAuthCh">
      <el-table size="small" :data="customerList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column align="center" type="selection" width="40">
        </el-table-column>
        <!-- <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column> -->
        <el-table-column prop="customer_name" align="center" label="客户名称" min-width="180" fixed="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #407AA8;cursor: pointer;" title="查看客户详情" @click="handleCustomerInfo(scope.$index, scope.row)">{{ scope.row.customer_name }}</span>
            <span v-if="scope.row.is_new==2" class="newTag">new</span>
          </template>
        </el-table-column>
        <el-table-column prop="contacts" align="center" label="联系人" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #407AA8;cursor: pointer;" title="查看所有联系人" @click="editContacts(scope.$index, scope.row)">{{ scope.row.contacts }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="inventors" align="center" label="前二发明人" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #407AA8;cursor: pointer;" title="查看所有发明人" @click="viewInventors(scope.$index, scope.row)">{{ scope.row.inventors }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="admin_name" align="center" label="当前跟进人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="old_admin_name" align="center" label="历史跟进人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="customer_type" align="center" label="客户类型" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="organ" align="center" label="部门/院系" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="position" align="center" label="职位/岗位" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="origin" align="center" label="来源" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="case_time" align="center" label="最新业务时间" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="添加时间" width="120" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column align="center" label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" :disabled="scope.row.able" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>

    <!--意向客户-->
    <div v-if="intentionCustomerAuthCh">
      <el-table size="small" :data="intentionCustomer" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="origin" align="center" label="客户名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="name" align="center" label="联系人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="seller" align="center" label="当前跟进人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="seller" align="center" label="历史跟进人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="seller" align="center" label="客户类型" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="seller" align="center" label="部门/岗位" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="seller" align="center" label="来源" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column prop="add_time" align="center" label="录入时间" show-overflow-tooltip>
        </el-table-column> -->
        <!-- <el-table-column class="u-btn">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-delete" class="u-btn" @click="delClue(scope.$index, scope.row)">删除</el-button>
            <el-button size="mini" type="primary" icon="el-icon-delete" class="u-btn" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!--客户公海-->
    <div v-if="customerPoolAuthCh">
      <el-table size="small" :data="customerPool" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" ref="multipleTable" @selection-change="handleSelectionChange" style="width: 100%;">
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="contacts" align="center" label="联系人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="old_admin_name" align="center" label="历史跟进人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="customer_type" align="center" label="客户类型" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="organ" align="center" label="部门/院系" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="position" align="center" label="职位/岗位" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column prop="seller" align="center" label="来源" show-overflow-tooltip>
        </el-table-column> -->
        <el-table-column prop="add_time" align="center" label="移入时间" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column class="u-btn">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-delete" class="u-btn" @click="delClue(scope.$index, scope.row)">删除</el-button>
            <el-button size="mini" type="primary" icon="el-icon-delete" class="u-btn" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!--客户管理-->
    <div v-if="customerManageAuthCh">
      <el-table size="small" :data="customerManage" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="origin" align="center" label="客户名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="name" align="center" label="联系人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="seller" align="center" label="当前跟进人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="seller" align="center" label="历史跟进人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="seller" align="center" label="客户类型" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="seller" align="center" label="部门/岗位" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="seller" align="center" label="来源" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column prop="add_time" align="center" label="录入时间" show-overflow-tooltip>
        </el-table-column> -->
        <!-- <el-table-column class="u-btn">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-delete" class="u-btn" @click="delClue(scope.$index, scope.row)">删除</el-button>
            <el-button size="mini" type="primary" icon="el-icon-delete" class="u-btn" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 新增客户页面 -->
    <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="addFormVisible" width="850px">
        <el-form label-width="120px" :model="addCustomerForm" :rules="addCustomerFormRule" ref="addCustomerForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="客户名称" prop="customer_name">
                <el-input size="small" v-model.trim="addCustomerForm.customer_name" auto-complete="off" placeholder="例:西南石油大学-房XX">
                  <el-button  style="padding-right: 10px;" slot="suffix" type="text" @click="searchRepeat">查重</el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="contacts">
                <el-input size="small" v-model.trim="addCustomerForm.contacts" auto-complete="off" clearable></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="mobile">
                <el-input size="small" v-model.trim="addCustomerForm.mobile" auto-complete="off" clearable></el-input>
              </el-form-item>
              <el-form-item label="跟进人" prop="admin_name">
                <el-input size="small" v-model.trim="addCustomerForm.admin_name" auto-complete="off" clearable disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="部门/院系" prop="organ">
                <el-input size="small" v-model.trim="addCustomerForm.organ" auto-complete="off" clearable></el-input>
              </el-form-item>
              <el-form-item label="职位/岗位" prop="position">
                <el-input size="small" v-model.trim="addCustomerForm.position" auto-complete="off" clearable></el-input>
              </el-form-item>
              <el-form-item label="客户类型" prop="customer_type">
                <el-select size="small" v-model.trim="addCustomerForm.customer_type" placeholder="请选择">
                  <el-option v-for="type in customerType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户来源" prop="origin">
                <!-- <el-input size="small" v-model="addCustomerForm.origin" auto-complete="off" clearable></el-input> -->
                <el-select size="small" v-model.trim="addCustomerForm.origin" placeholder="请选择">
                  <el-option v-for="type in originArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button v-no-more-click size="mini" type="primary" @click="addCustomer('addCustomerForm')">提交</el-button>
            <el-button size="mini" @click='closeDialog("addCustomerForm")'>取消</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 管理新增客户页面 -->
    <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="adminAddFormVisible" width="850px">
        <el-form label-width="120px" :model="adminAddCustomerForm" :rules="adminAddCustomerFormRule" ref="adminAddCustomerForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="客户名称" prop="customer_name">
                <el-input size="small" v-model.trim="adminAddCustomerForm.customer_name" auto-complete="off" placeholder="例:西南石油大学-房XX">
                  <el-button  style="padding-right: 10px;" slot="suffix" type="text" @click="searchRepeat">查重</el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="contacts">
                <el-input size="small" v-model.trim="adminAddCustomerForm.contacts" auto-complete="off" clearable></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="mobile">
                <el-input size="small" v-model.trim="adminAddCustomerForm.mobile" auto-complete="off" clearable></el-input>
              </el-form-item>
              <el-form-item label="跟进人" prop="admin_id">
                <el-select size="small" v-model="adminAddCustomerForm.admin_id" placeholder="请选择" filterable clearable style="width: 250px;" @change="getAdminChangeName">
                  <el-option v-for="type in distributeSeller" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
                <!-- <el-input size="small" v-model.trim="adminAddCustomerForm.admin_name" auto-complete="off" clearable disabled></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="部门/院系" prop="organ">
                <el-input size="small" v-model.trim="adminAddCustomerForm.organ" auto-complete="off" clearable></el-input>
              </el-form-item>
              <el-form-item label="职位/岗位" prop="position">
                <el-input size="small" v-model.trim="adminAddCustomerForm.position" auto-complete="off" clearable></el-input>
              </el-form-item>
              <el-form-item label="客户类型" prop="customer_type">
                <el-select size="small" v-model.trim="adminAddCustomerForm.customer_type" placeholder="请选择">
                  <el-option v-for="type in customerType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户来源" prop="origin">
                <!-- <el-input size="small" v-model="addCustomerForm.origin" auto-complete="off" clearable></el-input> -->
                <el-select size="small" v-model.trim="adminAddCustomerForm.origin" placeholder="请选择">
                  <el-option v-for="type in originArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button v-no-more-click size="mini" type="primary" @click="adminAddCustomerBtn('adminAddCustomerForm')">提交</el-button>
            <el-button size="mini" @click='closeDialogByAdminAdd()'>取消</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 客户详情界面 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="infoFormVisible" width="1400px" class="customerInfoDialog_">
        <el-row>
          <el-col :span="6" style="height: 485px;">
          <span class="infoTitle">客户详情</span>
          <el-form label-width="100px" :model="infoCustomerForm" style="margin-top: 12px;" :rules="infoCustomerFormRule" ref="infoCustomerForm">
            <el-form-item label="客户名称" prop="customer_name">
              <el-input size="small" v-model.trim="infoCustomerForm.customer_name" auto-complete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
              <el-input size="small" v-model.trim="infoCustomerForm.contacts" auto-complete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="mobile">
              <el-input size="small" v-model.trim="infoCustomerForm.mobile" auto-complete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="跟进人" prop="admin_name">
              <el-input size="small" v-model="infoCustomerForm.admin_name" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="历史跟进人" prop="old_admin_name">
              <el-input size="small" v-model="infoCustomerForm.old_admin_name" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="客户类型" prop="customer_type">
              <!-- <el-input size="small" v-model="infoCustomerForm.customer_type" auto-complete="off" clearable></el-input> -->
              <el-select size="small" v-model.trim="infoCustomerForm.customer_type" placeholder="请选择" clearable style="width: 100%;">
                  <el-option v-for="type in customerType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="部门/院系" prop="organ">
              <el-input size="small" v-model.trim="infoCustomerForm.organ" auto-complete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="职位/岗位" prop="position">
              <el-input size="small" v-model.trim="infoCustomerForm.position" auto-complete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="客户来源" prop="origin">
              <!-- <el-input size="small" v-model="infoCustomerForm.origin" auto-complete="off" style="width: 210px;" clearable></el-input> -->
               <el-select size="small" v-model.trim="infoCustomerForm.origin" placeholder="请选择" style="width: 170px;" clearable>
                  <el-option v-for="type in originArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
              <el-button v-no-more-click size="mini" type="primary" @click="editCustomerData('infoCustomerForm')" style="float: right;margin-top: 7px;">提交</el-button>
            </el-form-item>
          </el-form>
          </el-col>
          <el-col :span="18" style="height: 485px;">
            <div style="display: flex;">
              <div>
                <span class="infoTitle" style="margin-left: 12px;">财务流水</span>
              </div>
              <div style="margin-left: auto;margin-right: 0px;">
                <el-form :inline="true" :model="customerFinanceForm">
                  <el-form-item label="时间" class="clueDatePicker" style="width: 300px;margin-top: -4px;">
                    <el-date-picker
                        v-model="searchDateValue"
                        @change="getSearchDate"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        unlink-panels
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00',  '23:59:59']"
                        style="width: 250px;">
                      </el-date-picker>
                  </el-form-item>
                  <el-input size="small" v-model.trim="customerFinanceForm.search" placeholder="请输入关键词" clearable style="width: 180px;"></el-input>
                  <el-button size="small" icon="el-icon-search" class="clue-btn" @click="searchCustomerFinance" style="margin-left: 20px;">查询</el-button>
                </el-form>
              </div>
            </div>
            
            <div style="margin-top: -2px;margin-left: 14px;overflow-y: auto;height: 100%;">
              <el-table size="small" :data="financeData" v-loading="financeLoading" border element-loading-text="拼命加载中" height="430" style="width: 100%;" tooltip-effect="dark">
                <el-table-column fixed prop="event_time" align="center" label="时间" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="apply_number" align="center" label="项目编号" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="apply_item" align="center" label="项目名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="income" align="center" label="收入金额" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="expense" align="center" label="支出金额" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="payer" align="center" label="付款单位" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="payee" align="center" label="收款单位" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="balance" align="center" label="余额" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="desc" align="center" label="备注" show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
        <div>
        <span class="infoTitle">客户案件</span>
        <div style="margin-left: 40px;margin-top: 10px;">
          <el-table size="small" :data="customerCaseLog" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" height="240" style="width: 100%;overflow-y: auto;">
            <el-table-column align="center" type="index" label="序号" width="60">
            </el-table-column>
            <el-table-column prop="case_name" align="center" label="案件名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="entrust" align="center" label="案件类型" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="add_time" align="center" label="时间" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </div>
        <!-- <span class="infoTitle">客户联系人</span> -->
        </div>
    </el-dialog>
    <!-- 客户导入 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="exportFormVisible" width="50%" @click="closeDialog('importForm')">
        <el-form label-width="120px">
          <el-row>
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx或xls文件，且不超过10M
                    <span style="margin-left: 15px;color: #551A8B;cursor: pointer;" title="下载客户导入excel模板" @click="downloadImportExcel()">下载客户模板</span>
                  </div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="repeatVisible" width="400px" style="text-align: center;">
      <span style="color: #FF0000;float: left;margin-top: -30px;font-size: 12px;">注：最多显示20个查重记录</span>
      <el-table size="small" :data="repeatCustomer" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;height: 300px;overflow-y: auto;">
        <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
        </el-table-column>
         <el-table-column prop="admin_name" align="center" label="业务人员" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </el-dialog>
    <div>
      <div class="rightDrawer" @click="handleDrawerOpen">
        《《
      </div>
      <el-drawer 
      :visible.sync="drawer" 
      :direction="direction" 
      :before-close="handleDrawerClose" 
      size="360px" 
      title="条件查询" 
      :show-close="false"
      :wrapperClosable="true"
      class="searchDrawer" 
      >
        <div style="margin-left: 20px;">
            <el-form :inline="true" :model="formInline">
              <el-form-item label="客户名称" style="width: 320px;">
                <el-input size="small" v-model.trim="formInline.customer_name" placeholder="请输入客户名称" clearable style="width: 250px;"></el-input>
              </el-form-item>
              <el-form-item label="联系方式" style="width: 320px;">
                <el-input size="small" v-model.trim="formInline.mobile" placeholder="请输入联系方式" clearable style="width: 250px;"></el-input>
              </el-form-item>
              <el-form-item label="部门院系" style="width: 320px;">
                <el-input size="small" v-model.trim="formInline.organ" placeholder="请输入部门院系" clearable style="width: 250px;"></el-input>
              </el-form-item>
              <el-form-item label="跟进商务" v-if="myCustomerAuthCh" style="width: 320px;">
                <el-select size="small" v-model.trim="formInline.admin_name" placeholder="请选择" filterable clearable style="width: 250px;">
                    <el-option v-for="type in searchSeller" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户类型" style="width: 320px;">
                <el-select size="small" v-model.trim="formInline.customer_type" placeholder="请选择" clearable style="width: 250px;">
                    <el-option v-for="type in customerType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="searchCustomer">查询</el-button>
                <el-button type="warning" size="small" @click="resetSearch">重置</el-button>
                <el-button type="danger" size="small" @click="handleDrawerClose">关闭</el-button>
              </el-form-item>
            </el-form>
        </div>
      </el-drawer>
    </div>
    <!-- 客户分配界面 -->
    <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="distributeVisible" width="850px">
        <!-- 下拉框选择分配商务 -->
        <el-form :inline="true" :model="distributeForm">
          <el-form-item label="分配商务" style="width: 320px;">
               <el-select size="small" v-model="distributeForm.admin_id" placeholder="请选择" filterable clearable style="width: 250px;" @change="getDistributeName">
                  <el-option v-for="type in distributeSeller" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
        </el-form>
        <!-- 勾选客户列表 -->
        <el-table size="small" :data="distributeCheckData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
          <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="contacts" align="center" label="联系人" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="admin_name" align="center" label="当前跟进人" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" width="90">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="delDistributeCus(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 确认分配 -->
        <el-form>
          <el-form-item>
            <el-button type="info" size="small" @click="closeDistribute" style="float: right;margin-left: 10px;margin-top: 10px;">关闭</el-button>
            <el-button type="primary" size="small" @click="commitDistribute" style="float: right;margin-top: 10px;">确认</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>

    <!-- 公海客户分配界面 -->
    <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="poolDistributeVisible" width="850px">
        <!-- 下拉框选择分配商务 -->
        <el-form :inline="true" :model="distributeForm">
          <el-form-item label="分配商务" style="width: 320px;">
               <el-select size="small" v-model="distributeForm.admin_id" placeholder="请选择" filterable clearable style="width: 250px;" @change="getDistributeName">
                  <el-option v-for="type in distributeSeller" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
        </el-form>
        <!-- 勾选客户列表 -->
        <el-table size="small" :data="distributeCheckData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
          <el-table-column prop="customer_name" align="center" label="客户名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="contacts" align="center" label="联系人" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="admin_name" align="center" label="当前跟进人" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" width="90">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="delDistributeCus(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 确认分配 -->
        <el-form>
          <el-form-item>
            <el-button type="info" size="small" @click="closePoolDistribute" style="float: right;margin-left: 10px;margin-top: 10px;">关闭</el-button>
            <el-button type="primary" size="small" @click="commitPoolDistribute" style="float: right;margin-top: 10px;">确认</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>

    <!-- 客户联系人管理界面 -->
    <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="contactsVisible" width="850px">
        <el-button size="small" type="primary" style="margin-bottom: 10px;" @click="addContacts">添加</el-button>
        <!-- 勾选客户列表 -->
        <el-table size="small" :data="contactsData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
          <el-table-column prop="name" align="center" label="姓名" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="organ" align="center" label="部门/院系" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="position" align="center" label="职位/岗位" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" width="90" label="操作">
            <template slot-scope="scope">
              <el-button v-no-more-click size="mini" type="danger" @click="delContacts(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-form>
          <el-form-item>
            <el-button type="info" size="small" @click="closeContacts" style="float: right;margin-left: 10px;margin-top: 10px;">关闭</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>

    <!-- 添加联系人界面 -->
    <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="addContactsVisible" width="850px">
      <el-form label-width="120px" :model="addContactForm" :rules="addContactFormRule" ref="addContactForm">
        <el-form-item label="姓名" prop="name">
          <el-input size="small" v-model.trim="addContactForm.name" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input size="small" v-model.trim="addContactForm.mobile" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="部门/院系" prop="organ">
          <el-input size="small" v-model.trim="addContactForm.organ" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="职位/岗位" prop="position">
          <el-input size="small" v-model.trim="addContactForm.position" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-button v-no-more-click size="mini" type="primary" @click="commitAddContacts('addContactForm')" style="display: flex;margin-left: auto;margin-right: 0px;">确定</el-button>
      </el-form>
    </el-dialog>
     <!-- 客户发明人管理界面 -->
     <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="inventorsVisible" width="850px">
        <el-button size="small" type="primary" style="margin-bottom: 10px;" @click="editInventors()">添加</el-button>
        <!-- 勾选客户列表 -->
        <el-table size="small" :data="inventorsData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
          <el-table-column prop="name" align="center" label="姓名" width="80" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="mobile" align="center" label="联系方式" width="100" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="company" align="center" label="单位/企业" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="position" align="center" label="职位/岗位" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="birth" align="center" label="出生年份" width="70" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" width="180" label="操作">
            <template slot-scope="scope">
              <el-button v-no-more-click size="mini" type="primary" @click="editInventors(scope.$index, scope.row)">编辑</el-button>
              <el-button v-no-more-click size="mini" type="danger" @click="delInventors(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-form>
          <el-form-item>
            <el-button type="info" size="small" @click="closeInventors" style="float: right;margin-left: 10px;margin-top: 10px;">关闭</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>

     <!-- 编辑发明人界面 -->
     <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="editInventorsVisible" width="850px">
      <el-form label-width="120px" :model="editInventorForm" :rules="editInventorFormRule" ref="editInventorForm">
        <el-form-item label="姓名" prop="name">
          <el-input size="small" v-model.trim="editInventorForm.name" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input size="small" v-model.trim="editInventorForm.mobile" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="单位/企业" prop="company">
          <el-input size="small" v-model.trim="editInventorForm.company" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="职位/岗位" prop="position">
          <el-input size="small" v-model.trim="editInventorForm.position" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="出生年份" prop="birth">
          <el-input size="small" v-model.trim="editInventorForm.birth" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-button v-no-more-click size="mini" type="primary" @click="commitEditInventors('editInventorForm')" style="display: flex;margin-left: auto;margin-right: 0px;">确定</el-button>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { 
  getMyCustomerList,
  getCustomerList, 
  addCustomer, 
  editCustomer, 
  getCustomerAction, 
  webUrl, 
  getCustomerIntention,
  getCustomerPool, 
  getSearchSeller,
  searchRepeatCustomer,
  distributeCustomerCheck,
  deleteCustomerCheck,
  getDistributeSeller,
  downloadCustomerSearch,
  getCustomerTypeList,
  customerMovePool,
  recoveryCustomer,
  allocationPool,
  getCustomerContacts,
  addCustomerContacts,
  delCustomerContacts,
  getCustomerFinanceAndCase,
  getCustomerFinance,
  adminAddCustomer,
  getCustomerInventors,
  editCustomerInventors,
  delCustomerInventors } from '../../api/crmMG'
import Pagination from '../../components/Pagination'
import '../../assets/js/directive'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      loading: false, //是显示加载
      financeLoading: false, //客户流失显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false, //控制添加客户页面显示与隐藏
      adminAddFormVisible: false, //控制管理添加客户页面显示与隐藏
      infoFormVisible: false, //控制客户详情页面显示与隐藏
      exportFormVisible: false, //控制客户导入页面显示与隐藏
      repeatVisible: false, //控制客户查重页面显示与隐藏
      distributeVisible: false, //控制客户分配弹窗页面显示与隐藏
      poolDistributeVisible: false, //控制公海客户分配弹窗页面显示与隐藏
      contactsVisible: false, //控制客户联系人弹窗页面显示与隐藏
      addContactsVisible: false, //控制添加客户联系人弹窗页面显示与隐藏
      inventorsVisible: false, //控制客户发明人弹窗页面显示与隐藏
      editInventorsVisible: false,//控制编辑客户发明人弹窗页面显示与隐藏
      // 权限开始
      myCustomerListAuth: true,
      myCustomerListAuthCh: true,
      myCustomerAuth: false,
      myCustomerAuthCh: false,
      intentionCustomerAuth: false,
      intentionCustomerAuthCh: false,
      customerPoolAuth: false,
      customerPoolAuthCh: false,
      customerManageAuth: false,
      customerManageAuthCh: false,
      addCustomerAuth: false,
      adminAddCustomerAuth: false,
      importCustomerAuth: false,
      downloadCustomerAuth: false,
      customerMoveAuth: false,
      customerPoolDistributeAuth: false,
      customerPoolRecoveryAuth: false,
      customerDistributeAuth: false,
      customerDeleteAuth: false,
      // 权限结束

      // 搜索框开始
      drawer: false,
      direction: 'rtl',
      // 搜索框结束

      multipleSelection: [],

      // 客户分配勾选数据
      distributeCheckData: [],

      title: '预览',
      formInline: {
        page: 1,
        ps: 15,
        customer_name: '',
        admin_name: '',
        customer_type: '',
        mobile: '',
        organ: ''
      },
      addCustomerForm: {
        customer_name: '',
        customer_type: '',
        contacts: '',
        organ: '',
        position: '',
        mobile: '',
        origin: ''
      },
      adminAddCustomerForm: {
        admin_id: '',
        admin_name: '',
        customer_name: '',
        customer_type: '',
        contacts: '',
        organ: '',
        position: '',
        mobile: '',
        origin: ''
      },
      distributeForm: {
        admin_id: '',
        admin_name: '',
        ids: ''
      },
      infoCustomerForm: {
        customer_id: '',
        customer_name: '',
        contacts: '',
        customer_type: '',
        mobile: '',
        organ: '',
        origin: '',
        position: '',
        admin_name: '',
        old_admin_name: ''
      },
      customerFinanceForm: {
        customer_id: '',
        startDate: '',
        endDate: '',
        search: ''
      },
      searchDateValue: '',
      addContactForm: {
        customer_id: '',
        name: '',
        mobile: '',
        organ: '',
        position: ''
      },
      editInventorForm: {
        id: '',
        customer_id: '',
        name: '',
        mobile: '',
        company: '',
        position: '',
        birth: ''
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/admin/customer/importCustomer',

      userparm: [], //搜索权限
      listData: [], //用户数据
      myCustomerList: [], //我的客户列表数据
      customerList: [], //客户列表数据
      intentionCustomer: [], //意向客户数据
      customerPool: [], //客户公海
      customerManage: [], //客户管理
      customerCaseLog: [], //客户详情案件列表
      repeatCustomer: [], //客户查重数据列表

      customerLogs: [], //客户跟进记录

      distributeSeller: [], //分配客户商务列表

      customer_id: '', //客户id
      contactsData: [], //客户联系人列表

      inventorsData: [], //发明人列表

      financeData: [], //财务流水数据

      // 客户类型(下拉)
      customerType: [
        // { key: '单位', value: '单位' },
        // { key: '高校', value: '高校' },
        // { key: '自然人', value: '自然人' },
      ],
      // 商务列表(查询)
      searchSeller: [],
      // 客户来源(下拉)
      originArr: [
        { key: '自主开发', value: '自主开发' },
        { key: '公司分配', value: '公司分配' },
        { key: '渠道合作', value: '渠道合作' },
        { key: '客户介绍', value: '客户介绍' },
      ],
      // 参数校验
      addCustomerFormRule: {
        customer_name:[{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        customer_type:[{ required: true, message: '请选择客户类型', trigger: 'blur' }],
        contacts:[{ required: true, message: '请输入联系人', trigger: 'blur' }],
        mobile:[{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        origin:[{ required: true, message: '请输入来源', trigger: 'blur' }],
        organ:[{ required: true, message: '请输入部门/院系', trigger: 'blur' }],
      },
      adminAddCustomerFormRule: {
        admin_id:[{ required: true, message: '请选择商务', trigger: 'blur' }],
        customer_name:[{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        
      },
      infoCustomerFormRule: {
        customer_name:[{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        customer_type:[{ required: true, message: '请选择客户类型', trigger: 'blur' }],
        contacts:[{ required: true, message: '请输入联系人', trigger: 'blur' }],
        mobile:[{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        origin:[{ required: true, message: '请输入来源', trigger: 'blur' }],
        organ:[{ required: true, message: '请输入部门/院系', trigger: 'blur' }],
      },
      addContactFormRule: {
        name:[{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile:[{ required: true, message: '请输入联系人手机号', trigger: 'blur' }],
        organ:[{ required: true, message: '请输入院系/部门', trigger: 'blur' }],
        position:[{ required: true, message: '请输入职位/岗位', trigger: 'blur' }],
      },
      editInventorFormRule: {
        name:[{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile:[{ required: true, message: '请输入手机号', trigger: 'blur' }],
        company:[{ required: true, message: '请输入单位/企业', trigger: 'blur' }],
        position:[{ required: true, message: '请输入职位/岗位', trigger: 'blur' }],
        birth:[{ required: true, message: '请输入出生年份', trigger: 'blur' }],
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    let btnAuth = JSON.parse(localStorage.getItem('btnAuth'))
    if(btnAuth.includes("addCustomerAuth")){
      this.addCustomerAuth = true
    }
    if(btnAuth.includes("adminAddCustomerAuth")){
      this.adminAddCustomerAuth = true
    }
    if(btnAuth.includes("importCustomerAuth")){
      this.importCustomerAuth = true
    }
    if(btnAuth.includes("customerDistributeAuth")){
      this.customerDistributeAuth = true
    }
    if(btnAuth.includes("customerMoveAuth")){
      this.customerMoveAuth = true
    }
    if(btnAuth.includes("customerDeleteAuth")){
      this.customerDeleteAuth = true
    }
    if(btnAuth.includes("customerPoolDistributeAuth")){
      this.customerPoolDistributeAuth = true
    }
    if(btnAuth.includes("customerPoolRecoveryAuth")){
      this.customerPoolRecoveryAuth = true
    }
    if(btnAuth.includes("downloadCustomerAuth")){
      this.downloadCustomerAuth = true
    }
    this.getMyCustomerListData()
    if(btnAuth.includes("myCustomerAuth")){
      this.myCustomerAuth = true
      if(!this.myCustomerListAuth){
        this.myCustomerAuthCh = true
        // 获取数据
        this.getCustomerListData()
      }
    }
    if(btnAuth.includes("intentionCustomerAuth")){
      this.intentionCustomerAuth = true
      if(!this.myCustomerAuth&&!this.myCustomerListAuth){
        this.intentionCustomerAuthCh = true
        // 获取数据
        this.getCustomerIntentionList()
      }
    }
    if(btnAuth.includes("customerPoolAuth")){
      this.customerPoolAuth = true
      if(!this.myCustomerAuth&&!intentionCustomerAuth&&!this.myCustomerListAuth){
        this.customerPoolAuthCh = true
        // 获取数据
        this.getCustomerPoolList()
      }
    }
    if(btnAuth.includes("customerManageAuth")){
      this.customerManageAuth = true
      if(!this.myCustomerAuth&&!intentionCustomerAuth&&!customerPoolAuth&&!this.myCustomerListAuth){
        this.customerManageAuthCh = true
        // 获取数据
        // this.getMenuData()
      }
    }
    this.getCustomerTypeData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.exportFormVisible = false
          this.getCustomerListData()
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }
    }, 
    // 视频上传oss 结束


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      if(this.myCustomerAuthCh){
          this.getCustomerListData()
      }else if(this.intentionCustomerAuthCh){
          this.getCustomerIntentionList()
      }else if(this.customerPoolAuthCh){
          this.getCustomerPoolList()
      }else{
          this.getMyCustomerListData()
      }
    },
    // 搜索
    searchCustomer() {
      this.formInline.page = 1
      if(this.myCustomerAuthCh){
          this.getCustomerListData()
      }else if(this.intentionCustomerAuthCh){
          this.getCustomerIntentionList()
      }else if(this.customerPoolAuthCh){
          this.getCustomerPoolList()
      }else{
          this.getMyCustomerListData()
      } 
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
    },
    // label切换
    clickLabel(label) {
      this.formInline.page = 1
      if(label == 'list'){
        // this.getAccountData()
        this.getCustomerListData()
        this.myCustomerAuthCh = true;
        this.intentionCustomerAuthCh = false;
        this.customerPoolAuthCh = false;
        this.customerManageAuthCh = false;
        this.myCustomerListAuthCh = false;
      }else if(label == 'intention') {
        this.getCustomerIntentionList()
        this.myCustomerAuthCh = false;
        this.intentionCustomerAuthCh = true;
        this.customerPoolAuthCh = false;
        this.customerManageAuthCh = false;
        this.myCustomerListAuthCh = false;
      }else if(label == 'pool') {
        this.getCustomerPoolList()
        this.myCustomerAuthCh = false;
        this.intentionCustomerAuthCh = false;
        this.customerPoolAuthCh = true;
        this.customerManageAuthCh = false;
        this.myCustomerListAuthCh = false;
      }else{
        this.getMyCustomerListData()
        this.myCustomerAuthCh = false;
        this.intentionCustomerAuthCh = false;
        this.customerPoolAuthCh = false;
        this.customerManageAuthCh = false;
        this.myCustomerListAuthCh = true;
      }
    },
    // 获取我的客户列表
    getMyCustomerListData(){
      this.loading = true
      getMyCustomerList(this.formInline)
      .then(res=>{
        res = checkLogin(res);
        if(res.code == 200){
            this.myCustomerList = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
       }
      })
    },
    // 获取客户列表
    getCustomerListData() {
      this.loading = true
      getCustomerList(this.formInline)
      .then(res=>{
        res = checkLogin(res);
        if(res.code == 200){
            this.customerList = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
       }
      })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 显示添加客户页面
    handleAddCustomer() {
      let user = localStorage.getItem('userdata')
      let userInfo = JSON.parse(user)
      this.addCustomerForm.admin_name = userInfo.real_name
      this.title = '添加客户'
      this.addFormVisible = true
      this.addCustomerForm.customer_name = ''
      this.addCustomerForm.customer_type = ''
      this.addCustomerForm.contacts = ''
      this.addCustomerForm.organ = ''
      this.addCustomerForm.position = ''
      this.addCustomerForm.mobile = ''
      this.addCustomerForm.origin = ''
    },
    // 显示管理添加客户页面
    handleAdminAddCustomer(){
      let that = this
      // 查询商务列表
      getDistributeSeller()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          that.distributeSeller = res.data
          that.title = '添加客户'
          that.adminAddFormVisible = true
          that.adminAddCustomerForm.customer_name = ''
          that.adminAddCustomerForm.customer_type = ''
          that.adminAddCustomerForm.contacts = ''
          that.adminAddCustomerForm.organ = ''
          that.adminAddCustomerForm.position = ''
          that.adminAddCustomerForm.mobile = ''
          that.adminAddCustomerForm.origin = ''
          that.adminAddCustomerForm.admin_id = ''
          that.adminAddCustomerForm.admin_name = ''

        }else{
          that.$message({
            type: 'warning',
            message: '系统卡顿,请稍后再试!'
          })
          return false
        }
      })
    },
    // 添加客户
    addCustomer(addCustomerForm){
      this.$refs[addCustomerForm].validate(valid => {
        if(valid){
          if(this.addCustomerForm.customer_type == '高校'){
            // 高校客户需要多一些判断
            if(this.addCustomerForm.position.length <= 0 || this.addCustomerForm.organ.length <= 0){
              this.$message({
                type: 'warning',
                message: '高校客户必须填写部门和职位!'
              })
              return false
            }
            // 校验客户名称 必须是xxxx-xxx
            let mate = /-/;
            if(!mate.test(this.addCustomerForm.customer_name)){
              this.$message({
                type: 'warning',
                message: '客户名称格式错误!格式：xxx-xx'
              })
              return false
            }
          }
          addCustomer(this.addCustomerForm)
            .then(res=>{
              res = checkLogin(res);
              if(res.code == 200){
                this.$message({
                    type: 'success',
                    message: res.msg
                })
                this.addFormVisible = false
                this.getCustomerListData()
              }else{
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
        }else{
          return false
        }
      })

    },
    // 管理添加客户
    adminAddCustomerBtn(adminAddCustomerForm){
      this.$refs[adminAddCustomerForm].validate(valid => {
        if(valid){
          adminAddCustomer(this.adminAddCustomerForm)
            .then(res=>{
              res = checkLogin(res);
              if(res.code == 200){
                this.$message({
                    type: 'success',
                    message: res.msg
                })
                this.adminAddFormVisible = false
                this.getCustomerListData()
              }else{
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
        }else{
          return false
        }
      })
    },
    // 修改客户信息
    editCustomerData(infoCustomerForm) {
      this.$refs[infoCustomerForm].validate(valid => {
        if(valid){
          if(this.infoCustomerForm.customer_type == '高校'){
            // 高校客户需要多一些判断
            if(this.infoCustomerForm.position.length <= 0 || this.infoCustomerForm.organ.length <= 0){
              this.$message({
                type: 'warning',
                message: '高校客户必须填写部门和职位!'
              })
              return false
            }
            // 校验客户名称 必须是xxxx-xxx
            let mate = /-/;
            if(!mate.test(this.infoCustomerForm.customer_name)){
              this.$message({
                type: 'warning',
                message: '客户名称格式错误!格式：xxx-xx'
              })
              return false
            }
          }
          editCustomer(this.infoCustomerForm)
            .then(res=>{
              res = checkLogin(res);
              if(res.code == 200){
                this.$message({
                    type: 'success',
                    message: res.msg
                })
                this.infoFormVisible = false
                this.getCustomerListData()
              }else{
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
        }else{
          return false
        }
      })
    },
    // 客户详情页面显示
    handleCustomerInfo(index, row) {
      let userData = JSON.parse(localStorage.getItem('userdata'))
      let sign = userData.sign
      if(row.able && sign != 'flowhelp'){
        this.$message({
          type: 'warning',
          message: '你无权查看!'
        })
        return false
      }
      // 查询客户跟进记录
      // 查询客户案件信息
      this.title = '客户详情'
      this.infoCustomerForm.customer_id = row.id
      this.infoCustomerForm.customer_name = row.customer_name
      this.infoCustomerForm.customer_type = row.customer_type
      this.infoCustomerForm.contacts = row.contacts
      this.infoCustomerForm.mobile = row.mobile
      this.infoCustomerForm.organ = row.organ
      this.infoCustomerForm.origin = row.origin
      this.infoCustomerForm.position = row.position
      this.infoCustomerForm.admin_name = row.admin_name
      this.infoCustomerForm.old_admin_name = row.old_admin_name
      this.infoFormVisible = true
      this.customerFinanceForm.customer_id = row.id
      getCustomerFinanceAndCase({customer_id: row.id})
      .then(res=>{
        res = checkLogin(res);
        if(res.code == 200){
          this.financeData = res.data.financeList
          this.customerCaseLog = res.data.caseList
        }else{
          this.financeData = []
          this.customerCaseLog = []
        }
      })
    },
    // 查询客户流水
    searchCustomerFinance(){
      this.financeLoading = true
      getCustomerFinance(this.customerFinanceForm)
      .then(res=>{
        this.financeLoading = false
        res = checkLogin(res);
        if(res.code == 200){
          this.financeData = res.data
        }else{
          this.financeData = []
        }
      })
    },
    // 编辑联系人
    editContacts(index, row) {
      // 先查询联系人数据
      // 显示编辑联系人列表
      if(!row.is_edit){
        this.$message({
          type: 'info',
          message: '你无权查看!'
        })
        return false
      }
      let customer_id = row.id
      // 查询联系人列表
      let param = {customer_id: customer_id}
      getCustomerContacts(param)
      .then(res=>{
        if(res.code == 200){
          this.customer_id = customer_id
          this.contactsData = res.data
          this.title = '联系人管理'
          this.contactsVisible = true
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
          return false
        }
      })
    },
    // 查看发明人
    viewInventors(index, row){
      // 先查询联系人数据
      // 显示编辑联系人列表
      if(!row.is_edit){
        this.$message({
          type: 'info',
          message: '你无权查看!'
        })
        return false
      }
      let customer_id = row.id
      // 查询联系人列表
      let param = {customer_id: customer_id}
      getCustomerInventors(param)
      .then(res=>{
        if(res.code == 200){
          this.customer_id = customer_id
          this.inventorsData = res.data
          this.title = '发明人管理'
          this.inventorsVisible = true
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
          return false
        }
      })
    },
    // 查询联系人列表
    getCustomerContactsList(id) {
      let param = { customer_id: id }
      getCustomerContacts(param)
      .then(res=>{
        if(res.code == 200){
          this.contactsData = res.data
        }
      })
    },
      // 查询发明人列表
    getCustomerInventorsList(id) {
      let param = { customer_id: id }
      getCustomerInventors(param)
      .then(res=>{
        if(res.code == 200){
          this.inventorsData = res.data
        }
      })
    },
    // 导入客户页面显示
    handleExportCustomer() {
      this.title = '客户导入'
      this.exportFormVisible = true
    },
    // 下载客户导入模板
    downloadImportExcel() {
      console.log(99999)
    },
    // 查询意向客户列表
    getCustomerIntentionList() {
      getCustomerIntention(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.intentionCustomer = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 查询客户公海列表
    getCustomerPoolList() {
      getCustomerPool(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.customerPool = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 开启搜索框
    handleDrawerOpen() {
      let that = this
      getSearchSeller()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          that.searchSeller = res.data
        }else{
          that.searchSeller = []
        }
      })
      this.drawer = true
    },
    // 关闭搜索框
    handleDrawerClose() {
      this.drawer = false
    },
    // 客户名称查重
    searchRepeat() {
      let customerName = this.addCustomerForm.customer_name
      if(customerName.length <= 0){
        return false
      }
      searchRepeatCustomer({searchCustomer: customerName})
      .then(res=>{
        this.title = '客户信息'
        this.repeatCustomer = res.data
        this.repeatVisible = true
      })
    },

    // 监听日期选择器值的变化
    getSearchDate() {
      let dateValue = this.searchDateValue
      if(dateValue){
        this.customerFinanceForm.startDate = dateValue[0]
        this.customerFinanceForm.endDate = dateValue[1]
      }else{
        this.customerFinanceForm.startDate = ''
        this.customerFinanceForm.endDate = ''
      }
    },
    // 刷新数据
    refreshData() {
      console.log('刷新数据!')
      // this.formInline.page = 1
      if(this.myCustomerAuthCh){
          this.getCustomerListData()
      }else if(this.intentionCustomerAuthCh){
          this.getCustomerIntentionList()
      }else if(this.customerPoolAuthCh){
          this.getCustomerPoolList()
      }else{
        this.getMyCustomerListData()
      }
    },
    // 重置搜索
    resetSearch() {
        this.formInline.customer_name = ''
        this.formInline.admin_name = ''
        this.formInline.customer_type = ''
        this.formInline.mobile = ''
        if(this.myCustomerAuthCh){
          this.getCustomerListData()
      }else if(this.intentionCustomerAuthCh){
          this.getCustomerIntentionList()
      }else if(this.customerPoolAuthCh){
          this.getCustomerPoolList()
      }else{
          this.getMyCustomerListData()
      }
        // this.getCustomerListData()
    },
    // 显示客户分配弹窗
    handleDistributeCus() {
      let checks = this.multipleSelection;
      let that = this
      if(checks.length <= 0){
        this.$message({
          type: 'warning',
          message: '暂无勾选数据!'
        })
        return false
      }
      // 查询商务列表
      getDistributeSeller()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          that.distributeSeller = res.data
        }else{
          this.$message({
            type: 'warning',
            message: '系统卡顿,请稍后再试!'
          })
          return false
        }
      })
      this.title = '客户分配'
      this.distributeCheckData = checks
      this.distributeVisible = true
    },

      // 显示公海客户分配弹窗
    handlePoolDistributeCus() {
      let checks = this.multipleSelection;
      let that = this
      if(checks.length <= 0){
        this.$message({
          type: 'warning',
          message: '暂无勾选数据!'
        })
        return false
      }
      // 查询商务列表
      getDistributeSeller()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          that.distributeSeller = res.data
        }else{
          this.$message({
            type: 'warning',
            message: '系统卡顿,请稍后再试!'
          })
          return false
        }
      })
      this.title = '公海客户分配'
      this.distributeCheckData = checks
      this.poolDistributeVisible = true
    },
    // 客户移入公海
    handleMoveCus() {
      let checks = this.multipleSelection
      if(checks.length <= 0){
        this.$message({
          type: 'warning',
          message: '暂未勾选任何数据!'
        })
        return false
      }
      this.$confirm('确定将勾选中的客户移入公海吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let idArr = []
        checks.forEach(function(item,index){
          idArr.push(item.id)
        })
        let ids = JSON.stringify(idArr)
        customerMovePool({ids: ids})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            // 删除成功,刷新数据
            this.formInline.page = 1
            this.formInline.ps = 15
            this.formInline.customer_name = ''
            this.formInline.admin_name = ''
            this.formInline.customer_type = ''
            this.formInline.mobile = ''
            this.getCustomerListData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 批量删除客户(勾选)
    handleDelCusCheck() {
      let checks = this.multipleSelection;
      if(checks.length <= 0){
        this.$message({
          type: 'warning',
          message: '暂无勾选数据!'
        })
        return false
      }
      this.$confirm('确定删除勾选中的数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let idArr = []
        checks.forEach(function(item,index){
          idArr.push(item.id)
        })
        let ids = JSON.stringify(idArr)
        deleteCustomerCheck({ids: ids})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            // 删除成功,刷新数据
            this.formInline.page = 1
            this.formInline.ps = 15
            this.formInline.customer_name = ''
            this.formInline.admin_name = ''
            this.formInline.customer_type = ''
            this.formInline.mobile = ''
            this.getCustomerListData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 公海客户回收(勾选)
    handleRecoveryCusCheck() {
      let checks = this.multipleSelection;
      if(checks.length <= 0){
        this.$message({
          type: 'warning',
          message: '暂无勾选数据!'
        })
        return false
      }
      this.$confirm('确定恢复勾选中的客户数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let idArr = []
        checks.forEach(function(item,index){
          idArr.push(item.id)
        })
        let ids = JSON.stringify(idArr)
        recoveryCustomer({ids: ids})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getCustomerPoolList()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })


      
    },
    // 删除分配页面勾选的数据
    delDistributeCus(index,row) {
      let id = row.id
      let checks = this.distributeCheckData
      if(checks.length == 1){
        this.distributeCheckData = []
        this.distributeVisible = false
        return false
      }
      let newChecks = []
      checks.forEach(function(item,index){
        if(item.id != id){
          newChecks.push(item)
        }
      })
      this.distributeCheckData = newChecks
    },
    // 关闭客户分配界面
    closeDistribute() {
      this.distributeVisible = false
    },
    // 关闭公海客户分配界面
    closePoolDistribute() {
      this.poolistributeVisible = false
    },
    // 关闭联系人管理界面
    closeContacts() {
      this.contactsVisible = false
    },
    // 关闭发明人管理界面
    closeInventors() {
      this.inventorsVisible = false
    },
    // 提交客户分配信息
    commitDistribute() {
      let admin_id = this.distributeForm.admin_id
      let admin_name = this.distributeForm.admin_name
      if(admin_id.length <= 0 || admin_name <= 0){
        this.$message({
          type: 'error',
          message: '分配商务不能为空!'
        })
        return false
      }
      let idArr = []
      this.distributeCheckData.forEach(function(item,index){
        idArr.push(item.id)
      })
      this.distributeForm.ids = JSON.stringify(idArr)
      distributeCustomerCheck(this.distributeForm)
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.distributeVisible = false
          this.getCustomerListData()
        }else{
          this.$message({
            type: 'danger',
            message: res.msg
          })
        }
      })
      // console.log(this.distributeForm)
    },
    // 提交公海客户分配信息
    commitPoolDistribute() {
      let admin_id = this.distributeForm.admin_id
      let admin_name = this.distributeForm.admin_name
      if(admin_id.length <= 0 || admin_name <= 0){
        this.$message({
          type: 'error',
          message: '分配商务不能为空!'
        })
        return false
      }
      let idArr = []
      this.distributeCheckData.forEach(function(item,index){
        idArr.push(item.id)
      })
      this.distributeForm.ids = JSON.stringify(idArr)
      allocationPool(this.distributeForm)
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.poolDistributeVisible = false
          this.getCustomerPoolList()
        }else{
          this.$message({
            type: 'danger',
            message: res.msg
          })
        }
      })
      // console.log(this.distributeForm)
    },
    // 监听分配商务值变化
    getDistributeName(val) {
      let seller = this.distributeSeller
      let that = this
      seller.forEach(function(item,index){
        if(item.value == val){
          that.distributeForm.admin_name = item.key
        }
      })
    },
    // 监听管理选择商务值变化
    getAdminChangeName(val){
      let seller = this.distributeSeller
      let that = this
      seller.forEach(function(item,index){
        if(item.value == val){
          that.adminAddCustomerForm.admin_name = item.key
        }
      })
    },
    // 导出满足条件的客户信息
    downloadCustomerCheck() {
      this.$confirm('确定下载满足条件的客户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        downloadCustomerSearch(this.formInline)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: '下载成功!'
            }) 
            window.location.href = res.data.url
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 查询客户类型(数据字典)
    getCustomerTypeData() {
      getCustomerTypeList()
      .then(res=>{
        if(res.code == 200){
          this.customerType = res.data
        }
      })
    },
    // 删除联系人
    delContacts(index,row) {
      let contacts = this.contactsData
      let customer_id = this.customer_id
      if(contacts.length<=1){
        this.$message({
          type: 'info',
          message: '至少保留一个联系人'
        })
        return false
      }

      let param = { id: row.id }
      this.$confirm('确定删除联系人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        delCustomerContacts(param)
        .then(res=>{
          if(res.code==200){
            this.getCustomerContactsList(customer_id)
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
      
    },
    // 显示添加联系人界面
    addContacts() {
      this.title = '添加联系人'
      this.addContactsVisible = true
      let cid = this.customer_id
      this.addContactForm.customer_id = cid
    },
    // 关闭添加联系人弹窗
    closeAddContacts() {
      this.addContactsVisible = false
    },
    // 提交添加联系人表单
    commitAddContacts(addContactForm) {
      let cid = this.customer_id
      this.$refs[addContactForm].validate(valid => {
        if(valid){
          addCustomerContacts(this.addContactForm)
          .then(res=>{
            if(res.code==200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getCustomerContactsList(cid)
              this.addContactsVisible = false
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })

        }else{
          return false
        }
      })
    },
    // 编辑发明人弹窗
    editInventors(index,row) {
      if(row){
        this.editInventorForm.id = row.id
        this.editInventorForm.customer_id = row.customer_id
        this.editInventorForm.name = row.name
        this.editInventorForm.mobile = row.mobile
        this.editInventorForm.company = row.company
        this.editInventorForm.position = row.position
        this.editInventorForm.birth = row.birth
      }else{
        this.editInventorForm.id = ''
        this.editInventorForm.customer_id = this.customer_id
        this.editInventorForm.name = ''
        this.editInventorForm.mobile = ''
        this.editInventorForm.company = ''
        this.editInventorForm.position = ''
        this.editInventorForm.birth = ''
      }
      this.title = "编辑发明人"
      this.editInventorsVisible = true
    },
     // 提交编辑发明人表单
    commitEditInventors(editInventorForm) {
      let cid = this.customer_id
      this.$refs[editInventorForm].validate(valid => {
        if(valid){
          editCustomerInventors(this.editInventorForm)
          .then(res=>{
            if(res.code==200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getCustomerInventorsList(cid)
              this.editInventorsVisible = false
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })

        }else{
          return false
        }
      })
    },
    // 删除发明人
    delInventors(index,row) {
      let customer_id = this.customer_id
      let param = { id: row.id }
      this.$confirm('确定删除发明人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        delCustomerInventors(param)
        .then(res=>{
          if(res.code==200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getCustomerInventorsList(customer_id)
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
      
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'addCustomerForm'){
        this.addFormVisible = false
      }
      this.$refs[formName].resetFields()
    },
    // 关闭管理添加客户弹窗
    closeDialogByAdminAdd(){
      this.adminAddFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.clue-btn {
  background-color: #333333;
  color: #FFFFFF;
}
.clue-search {
  margin-left: 20px;
  background-color: #E4E4E4;
}
.clue-search-btn {
  background-color: #333333 !important;
  color: #FFFFFF !important;
  font-weight: 700 !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.u-btn {
  display: none;
}
.mouse {
  cursor: pointer;
  color: #D9D9D9;
  margin-right: 18px;
}
.selected {
  color: #333333;
}
.newTag {
  margin-left: 6px;
  background-color: #00C8DF;
  color: #FFFFFF;
  border-radius: 10px;
  padding: 1.5px 4px;
}
.infoTitle {
  font-size: 18px;
  font-weight: 700;
  color: #333333;
  margin-left: 40px;
}
.customerInfoDialog>>>.el-form-item {
  margin-bottom: 0px !important;
}
.customerInfoDialog_>>>.el-form-item {
  margin-bottom: 10px !important;
}
.customerInfoDialog_>>>.el-form-item__error{
  padding-top: 0px !important;
}
.rightDrawer {
  width: 40px;
  height: 100px;
  background-color: #00C8DF;
  position: absolute;
  border-radius: 10px 0px 0px 10px;
  left: auto;
  right: 0;
  top: 40%;
  z-index: 10;
  color: #FFFFFF;
  text-align: center;
  margin-top: auto;
  line-height: 100px;
  cursor: pointer;
}
.searchDrawer {
  height: 80vh;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 20px 0px 0px 20px;
}
.clueDatePicker>>>.el-range-editor.el-input__inner {
  padding: 1px 4px;
}
.clueDatePicker>>>.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 215px;
  height: 34px;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/crm/customer.vue